import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText, formatVal } from '../../../../helpers/value'
import { selectCompanyInfo } from '../../../common/header/companyInfo/store/slice'
import { selectKeyFinancialById } from '../../store/slice'
import { UNIT_FINANCIAL } from './helper'

export const Value = ({ rowId }) => {
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectKeyFinancialById(rowId))
  const { fiscalYearEnd } = useSelector(selectCompanyInfo)
  const year = new Date(fiscalYearEnd).getFullYear()
  const { formatCurrency } = useFormatCurrency(SCREEN.SUMMARY)

  const renderValue = () => {
    const value = data.values[data.values.length - 1]?.value

    switch (data.unit) {
      case UNIT_FINANCIAL.VND:
        return formatCurrency({
          value,
          year,
          exchangeRateType: data.exchangeRateType,
          isFinancialStatement: true,
        })
      case UNIT_FINANCIAL.PERCENT:
        return formatVal(value * 100, locale, true)
      default:
        return formatText(value)
    }
  }

  return <div className="textEnd">{renderValue()}</div>
}
